import React from 'react';
import classNames from 'classnames';
import Logo from './Logo';
import ClientSelector from './clientSelector/ClientSelector';
import Hamburger from './mobileMenu/Hamburger';
import Help from './headerIcons/Help';
import AnnounceKit from './headerIcons/AnnounceKit';
import Avatar from './headerIcons/Avatar';

export default function Header({
    clients,
    currentClient,
    changeClient,
    currentApp,
    activeSubnavItem,
    currentUser,
    navigateToUrl,
}) {
    return (
        <div className="flex items-center w-full bg-white h-15 z-40 justify-between p-4 shadow-none sm:shadow-sm">
            <div className="ml-0.5 sm:ml-2 md:ml-5 flex flex-none h-10 items-center">
                <div className="block md:hidden">
                    <Hamburger
                        clients={clients}
                        changeClient={changeClient}
                        currentClient={currentClient}
                        currentApp={currentApp}
                        currentUser={currentUser}
                        activeSubnavItem={activeSubnavItem}
                        navigateToUrl={navigateToUrl}
                    />
                </div>

                <div className="hidden md:block">
                    <Logo className="w-9 h-6" currentUser={currentUser} />
                </div>

                <HeadingDivider className="hidden md:block mx-5 md:ml-9 md:mr-8" />

                <ClientSelector
                    clients={clients}
                    changeClient={changeClient}
                    currentClient={currentClient}
                />
            </div>

            <div className="flex items-center h-10 sm:mr-2 md:mr-4 space-x-6">
                <Help />

                <AnnounceKit
                    currentUser={currentUser}
                    right
                    bg="bg-blue-700"
                    border
                    className="hidden xm:block"
                />

                <Avatar
                    currentUser={currentUser}
                    currentClient={currentClient}
                    navigateToUrl={navigateToUrl}
                />
            </div>
        </div>
    );
}

function HeadingDivider({ className }) {
    return (
        <div
            className={classNames(
                'border-r',
                'w-px',
                'border-gray-400',
                'h-full',
                className,
            )}
        ></div>
    );
}
